<template>
  <OButton
    class="!p-0 shrink-0 w-48 h-48 grid place-items-center min-h-0 rounded-full"
  >
    <q-icon
      class="text-current"
      size="1.5rem"
      name="close"
      v-bind="iconProps"
    />
  </OButton>
</template>

<script setup>
import OButton from './OButton.vue';

const props = defineProps({
  iconProps: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss" scoped></style>
